/**
 * Quantity of a sastavnica line (sprint 5l §4): a positive number with up to three decimals,
 * typed with a comma or a dot (2,5 m of belt) and shown the Serbian way (decimal comma).
 */

export const QUANTITY_MAX_DECIMALS = 3;
/** `numeric(10,3)` server-side: seven integer digits. */
export const QUANTITY_MAX_INTEGER_DIGITS = 7;

/**
 * "2,5" / "2.5" / " 24 " → the number; null when empty, not a plain number, not > 0, or with
 * more than three decimals / seven integer digits (what the server would reject as well).
 */
export function parseQuantity(raw: string): number | null {
  const s = raw.trim().replace(",", ".");
  if (!/^\d+(\.\d+)?$/.test(s)) return null;
  const [whole, fraction = ""] = s.split(".");
  if (whole.replace(/^0+(?=\d)/, "").length > QUANTITY_MAX_INTEGER_DIGITS) return null;
  if (fraction.length > QUANTITY_MAX_DECIMALS) return null;
  const n = Number(s);
  return Number.isFinite(n) && n > 0 ? n : null;
}

/** 2.5 → "2,5"; 24 → "24"; 1250 → "1250" (no digit grouping — a quantity is not an amount of money). */
export function formatQuantity(n: number): string {
  if (!Number.isFinite(n)) return "—";
  return n.toLocaleString("sr-Latn-RS", { maximumFractionDigits: QUANTITY_MAX_DECIMALS, useGrouping: false });
}

/** "2,5 m" / "24 kom"; just the number without a unit. */
export function formatQuantityWithUnit(n: number, unit: string | null | undefined): string {
  const q = formatQuantity(n);
  return unit ? `${q} ${unit}` : q;
}
